<template>
	<div>
		<div class="container">
			<div class="navbar-head">
				<a href="/agreement"><img src="../assets/imgs/my/black_back.png" width="88" height="88"></a>
				<span class="page-title" style="color:#432F12;width:216px;left:267px;">用户规则</span>
			</div>
			<div class="agreement">
				<p class="head">千来聚易测会员规则</p>
				<p>一、建立会员制度的目的</p>
				<p class="ident">1.掌握顾客信息，更好的为顾客服务。</p>
				<p class="ident">2.提供更优惠的消费价格为长期光顾的顾客服务。</p>
				<p>二、会员注册及会员资格认证。</p>
				<p class="ident">1.会员注册时需提供：手机号。</p>
				<p class="ident">2.会员注册后，登陆账户只需通过手机号和验证码即可。</p>
				<p>三、会员等级。</p>
				<p class="ident">一级，限录入2人出生日期，一年365元。</p>
				<p class="ident">二级，限录入8人出生日期，一年999元。</p>
				<p>四、使用须知</p>
				<p class="ident">1.每个手机号对应一个账号，不得转借他人使用。</p>
				<p class="ident">2.详细阅读会员协议，自开通会员后，会员协议自动生效，双方应严格遵守。</p>
				<p class="ident">3.因会员办理费用较低，会员服务享受后，不再退费。</p>
				<p class="ident">4.特价服务不同时享受会员优惠。</p>
			</div>
		</div>
	</div>
</template>

<script>
import { baseMixin } from "../utils/base.js";
export default {
  name: "Agreement",
  mixins: [baseMixin],
};
</script>
<style>
	* {-webkit-box-sizing:unset ! important;}
	.ident {text-indent: 2em;}
</style>
